<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style scoped>
#app{
  height: 100%;
  width: 100%;
  background:url("assets/model.jpg")
}

</style>



// WEBPACK FOOTER //
// src/App.vue